import { render } from "./NoAccess.vue?vue&type=template&id=da71b846&scoped=true"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"

import "./NoAccess.vue?vue&type=style&index=0&id=da71b846&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da71b846"]])

export default __exports__